import React from 'react'
import { MetadataSettings, ShareProjectInput } from './partials'

function SharingForm() {
  return (
    <div className='SharingForm'>
      <div>
        <p>
          Do you need a link to view this project without authentication? You can either generate a pre-authenticated
          link or create an alias.
        </p>
      </div>
      <div className='SharingForm__options'>
        <ShareProjectInput />
        <MetadataSettings />
      </div>
      <br />
      <div>
        <p>
          For projects requiring a public link that is initially valid for more than 30 days, please contact us via
          Slack or the <a href='/help'>Help</a> section. <br /> You can learn more about sharing projects from{' '}
          <a href='https://dsn.adobe.com/docs/settings-and-sharing'>this document</a>.
        </p>
      </div>
    </div>
  )
}

export default SharingForm
